import { CustomerAPI, checkStatus, json } from '@drifthq/dapper'

export const fetchOnboardingStatus = () => {
  return CustomerAPI.get('/onboarding/state')
    .then(checkStatus)
    .then(json)
}

export const updateOnboardingStatus = (orgId, lastLocation, isComplete = false) => {
  return CustomerAPI.patch('/onboarding/state', {
    orgId,
    lastLocation,
    isComplete
  })
    .then(checkStatus)
    .then(json)
}


// WEBPACK FOOTER //
// ./src/modules/state/api.js